import { useState, useMemo } from "react";
import { extractDriveFolderId, extractDriveFileId } from "../utils/drive";

const LS_FOLDER = "galleryDriveFolderId";
const LS_ITEMS  = "galleryItems";     // fallback manual
const LS_API    = "galleryApiUrl";    // preferred

export default function Admin() {
  const [folderInput, setFolderInput] = useState(localStorage.getItem(LS_FOLDER) || "");
  const [itemsInput,  setItemsInput]  = useState((localStorage.getItem(LS_ITEMS) || "").split(",").join("\n"));
  const [apiInput,    setApiInput]    = useState(localStorage.getItem(LS_API) || "");
  const [saved, setSaved] = useState(false);

  const parsedFolderId = useMemo(() => extractDriveFolderId(folderInput), [folderInput]);
  const parsedFileIds  = useMemo(
    () => itemsInput.split(/\r?\n/).map(extractDriveFileId).filter(Boolean),
    [itemsInput]
  );

  const saveAll = () => {
    parsedFolderId ? localStorage.setItem(LS_FOLDER, parsedFolderId) : localStorage.removeItem(LS_FOLDER);
    parsedFileIds.length ? localStorage.setItem(LS_ITEMS, parsedFileIds.join(",")) : localStorage.removeItem(LS_ITEMS);
    apiInput.trim() ? localStorage.setItem(LS_API, apiInput.trim()) : localStorage.removeItem(LS_API);

    setSaved(true);
    setTimeout(() => setSaved(false), 1500);
  };

  return (
    <main>
      <section className="max-w-3xl mx-auto px-4 pt-10 pb-12">
        <h1 className="text-2xl sm:text-3xl font-bold mb-4 text-manupro-ink">
          Admin – Setări Galerie
        </h1>

        <div className="relative rounded-brand border bg-white/60 backdrop-blur-md shadow-glass border-white/70 p-5 space-y-6">
          <div className="pointer-events-none absolute inset-0 rounded-brand ring-1 ring-manupro-ring/20" />

          {/* A) API URL */}
          <div>
            <h2 className="font-semibold mb-2 text-manupro-ink">A) URL API Galerie (recomandat)</h2>
            <p className="text-sm text-gray-700 mb-3">
              Lipește mai jos <b>Web app URL</b> din Google Apps Script. Galeria va lista automat pozele din folder.
            </p>
            <input
              className="w-full rounded-xl border px-3 py-2 bg-white/80"
              placeholder="https://script.google.com/macros/s/AKfycb.../exec"
              value={apiInput}
              onChange={(e) => setApiInput(e.target.value)}
            />
            <p className="mt-2 text-xs text-gray-600">Dacă nu setezi API, se folosește fallback (B/C).</p>
          </div>

          {/* B) Folder ID (fallback) */}
          <div>
            <h2 className="font-semibold mb-2 text-manupro-ink">B) ID Folder Google Drive (fallback)</h2>
            <input
              className="w-full rounded-xl border px-3 py-2 bg-white/80"
              placeholder="https://drive.google.com/drive/folders/1AbCDE... sau doar 1AbCDE..."
              value={folderInput}
              onChange={(e) => setFolderInput(e.target.value)}
            />
            <p className="mt-2 text-xs text-gray-600">
              ID detectat: <code className="bg-gray-100 px-1 rounded">{parsedFolderId || "— (invalid)"}</code>
            </p>
          </div>

          {/* C) Listă manuală (fallback) */}
          <div>
            <h2 className="font-semibold mb-2 text-manupro-ink">C) Linkuri imagini (opțional, fallback)</h2>
            <textarea
              className="w-full rounded-xl border px-3 py-2 min-h-[140px] bg-white/80"
              placeholder="un link pe linie... (poți lăsa gol)"
              value={itemsInput}
              onChange={(e) => setItemsInput(e.target.value)}
            />
            <p className="mt-2 text-xs text-gray-600">Detectate: <b>{parsedFileIds.length}</b> imagini</p>
          </div>

          <div className="flex items-center gap-3">
            <button
              onClick={saveAll}
              className="rounded-brand px-5 py-2.5 font-medium text-white bg-manupro-primary hover:bg-manupro-teal shadow-brand ring-1 ring-manupro-ring/40 transition-colors"
            >
              Salvează
            </button>
            {saved && <span className="text-green-700 text-sm">Salvat ✓</span>}
            <span className="text-xs text-gray-500">
              Link admin: <code className="bg-gray-100 px-1 rounded">#34DQKMme41</code>
            </span>
          </div>
        </div>
      </section>
    </main>
  );
}
